/**
 * Sidebar Footer Component
 *
 * Footer content for the admin sidebar with Docs and Support links.
 *
 * @since 1.0.0
 */

import { BookOpenIcon, LifebuoyIcon } from '@heroicons/react/24/outline';
import { Flex } from '@redfoxwp/core-components/components/flex';
import { __ } from '@wordpress/i18n';

import { FooterLink, FooterWrapper } from './styled';

/**
 * Sidebar Footer component
 *
 * @since 1.0.0
 *
 * @return JSX element.
 */
export const SidebarFooter = (): JSX.Element => {
  const docsUrl = 'https://www.redfoxwp.com/docs/redfox-tab-manager/';
  const supportUrl = 'https://www.redfoxwp.com/support/';

  return (
    <FooterWrapper>
      <Flex direction='column' gap='20px'>
        <FooterLink href={docsUrl} target='_blank' rel='noopener noreferrer'>
          <BookOpenIcon width={16} height={16} />
          <span>{__('Documentation', 'redfox-tab-manager')}</span>
        </FooterLink>
        <FooterLink href={supportUrl} target='_blank' rel='noopener noreferrer'>
          <LifebuoyIcon width={16} height={16} />
          <span>{__('Support', 'redfox-tab-manager')}</span>
        </FooterLink>
      </Flex>
    </FooterWrapper>
  );
};
